import React from "react";

import Button from "../../../../components/Button";
import ContentModal from "../../../../components/Modal/Templates/ContentModal";
import Text from "../../../../components/Text";

import { ScanWarningModalProps } from "../../schema";

const ScanWarningModal = ({ show, onClose }: ScanWarningModalProps) => {
	if (!show) {
		return null;
	}

	return (
		<ContentModal
			handleClose={onClose}
			buttons={[
				<Button size="large" key="negative" color="blue" onClick={onClose}>
					Cancel
				</Button>,
			]}
		>
			<Text size="paragraph-1" weight="semi-bold">
				The virus scan is still pending or the resource is potentially unsafe.
			</Text>
		</ContentModal>
	);
};

export default ScanWarningModal;
